import React, { useState, useEffect, useRef } from "react";
import LoginModal from "./LoginModal";
import AddNameModal from "./AddNameModal";
import { isAuthenticated, removeTokens } from "../utils/jwt";
import { LuBadgePlus } from "react-icons/lu";
import { FiLogIn, FiLogOut } from "react-icons/fi";
import { VscSettingsGear } from "react-icons/vsc";

const TopNav = ({ syriacFontType, setSyriacFontType }) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isAddNameModalOpen, setIsAddNameModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSyriacMenuOpen, setIsSyriacMenuOpen] = useState(false);
  const syriacMenuRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    // Check if user is logged in using JWT
    setIsLoggedIn(isAuthenticated());
  }, []);

  const handleLogout = () => {
    // Clear JWT tokens
    removeTokens();
    setIsLoggedIn(false);
    // Optionally refresh the page
    window.location.reload();
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setIsLoginModalOpen(false);
  };

  const handleAddName = () => {
    setIsAddNameModalOpen(true);
  };

  const handleSettings = () => {
    window.open("https://filter-names-tool.vercel.app/", "_blank");
  };

  const handleSelectSyriacFont = (fontType) => {
    setSyriacFontType(fontType);
    setIsSyriacMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (syriacMenuRef.current && !syriacMenuRef.current.contains(event.target)) {
        setIsSyriacMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="main-header">
      <div className="header-left">
        <img
          src="../bk-logo.png"
          alt="BabyName Explorer Logo"
          className="header-logo"
          style={{ height: isMobile ? "15px" : "42px" }}
        />
        <h1
          className="header-title"
          style={{ fontSize: isMobile ? "1.5rem" : "2.5rem" }}
        >
          NAMES
        </h1>
      </div>
      <div
        className="header-right"
        style={{ display: "flex", gap: "12px", alignItems: "center" }}
      >
        <div className="syriac-dropdown" ref={syriacMenuRef}>
          <button
            onClick={() => setIsSyriacMenuOpen((prev) => !prev)}
            className="syriac-dropdown-trigger"
            aria-label="Select Syriac font type"
            aria-haspopup="menu"
            aria-expanded={isSyriacMenuOpen}
            title={`Current Syriac font: ${
              syriacFontType === "E" ? "Eastern Syriac" : "Western Syriac"
            }`}
          >
            {syriacFontType}
            <span className="syriac-dropdown-caret">▾</span>
          </button>
          {isSyriacMenuOpen && (
            <div className="syriac-dropdown-menu" role="menu">
              <button
                className={`syriac-dropdown-item ${
                  syriacFontType === "E" ? "syriac-dropdown-item-active" : ""
                }`}
                onClick={() => handleSelectSyriacFont("E")}
                role="menuitem"
              >
                Eastern Syriac
              </button>
              <button
                className={`syriac-dropdown-item ${
                  syriacFontType === "W" ? "syriac-dropdown-item-active" : ""
                }`}
                onClick={() => handleSelectSyriacFont("W")}
                role="menuitem"
              >
                Western Syriac
              </button>
            </div>
          )}
        </div>
        {isLoggedIn && (
          <button
            onClick={handleSettings}
            className="settings-btn"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: isMobile ? "8px" : "8px 16px",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#4B5563",
            }}
            title="Settings"
          >
            <VscSettingsGear size={20} />
          </button>
        )}
        <button
          onClick={handleAddName}
          className="add-name-btn"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: isMobile ? "8px" : "8px 16px",
            backgroundColor: "#7c3aed",
            color: "white",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontWeight: 500,
          }}
          title="Add Name"
        >
          <LuBadgePlus size={20} />
          {!isMobile && "Add Name"}
        </button>

        {isLoggedIn ? (
          <button
            onClick={handleLogout}
            className="login-link"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: isMobile ? "8px" : "8px 16px",
            }}
            title="Logout"
          >
            <FiLogOut size={20} />
            {!isMobile && "Logout"}
          </button>
        ) : (
          <button
            onClick={() => setIsLoginModalOpen(true)}
            className="login-link"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: isMobile ? "8px" : "8px 16px",
            }}
            title="Login"
          >
            <FiLogIn size={20} />
            {!isMobile && "Login"}
          </button>
        )}
      </div>
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLoginSuccess={handleLoginSuccess}
      />
      <AddNameModal
        isOpen={isAddNameModalOpen}
        onClose={() => setIsAddNameModalOpen(false)}
        onSuccess={() => {
          setIsAddNameModalOpen(false);
        }}
      />
    </header>
  );
};

export default TopNav;
